export function offerPartitionId (offer) {
  const shop = offer?._embedded?.shop
  return shop?._embedded?.parent?.id || shop?.id || offer?.shop
}
